import { MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '@zhiyue/core';
import { Button, Tooltip } from 'antd';
import React from 'react';

export default function ThemeToggle() {
  const { navTheme, setNavTheme } = useTheme();
  const dark = navTheme === 'realDark';
  const label = dark ? '切换为亮色主题' : '切换为暗色主题';
  return (
    <Tooltip title={label}>
      <Button
        type="text"
        aria-label={label}
        icon={dark ? <SunOutlined /> : <MoonOutlined />}
        onClick={() => setNavTheme(dark ? 'light' : 'realDark')}
      />
    </Tooltip>
  );
}
